<template>
  <div>
    <v-card class="mb-3 px-5 pa-7 rounded-xl" :elevation="0">
      <div
        class="text-left call-to-action-left-btn"
        @click="toggleAudienceSettings"
      >
        <v-icon class="call-to-action-left-icon">mdi-chevron-left</v-icon>
        Audience settings
      </div>
      <div class="mt-3">
        <v-list subheader two-line class="transparent">
          <!-- 1. Allow comments -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Comments</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Allow viewers to add comment
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_comments"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
          <!-- 2. Allow comments notifications -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Comments notification</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Get an email when someone comments
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_comments_notification"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
          <!-- 3. Allow emoji reactions -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Emoji reactions</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Allow viewers to add reactions
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_emoji_reactions"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
          <!-- 4. Allow download -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Download</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Allow viewers to download your video
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_download"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
          <!-- 5. Allow Call to action -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Call-to-action</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Allow viewers to see call-to-action
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_cta_display"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
          <!-- 6. Allow video analytics -->
          <v-list-item class="white mb-2 rounded-xl" elevation="2">
            <v-list-item-content class="text-left">
              <v-list-item-title>Analytics</v-list-item-title>
              <v-list-item-subtitle class="edit-card-subtitle">
                Allow viewers to see video analytics
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                true-value="yes"
                false-value="no"
                v-model="form.allow_analytics_view"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-row>
          <v-col cols="6" md="6" lg="6">
            <template>
              <v-btn
                block
                depressed
                class="rounded-xl text-capitalize"
                :loading="resetLoading"
                @click="setDefaultAnalyticsSettings"
              >
                Set default</v-btn
              >
            </template>
          </v-col>
          <v-col cols="6" md="6" lg="6">
            <template>
              <v-btn
                block
                depressed
                color="primary"
                class="rounded-xl text-capitalize"
                type="submit"
                :loading="loading"
                @click="saveAudienceSettings"
              >
                Save</v-btn
              >
            </template>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ResponseHelper from "../../utils/ResponseHelper";
export default {
  name: "AudienceSettings",
  props: {
    recordDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resetLoading: false,
      toast: new ResponseHelper(),
      form: {
        allow_comments: null,
        allow_comments_notification: null,
        allow_emoji_reactions: null,
        allow_download: null,
        allow_cta_display: null,
        allow_analytics_view: null,
      },
    };
  },
  methods: {
    ...mapActions({
      video_settings: "recordings/video_settings",
      update_analytics_settings: "recordings/update_analytics_settings",
      set_default_analytics_settings:
        "recordings/set_default_analytics_settings",
    }),
    async getVideoSettings() {
      try {
        const response = await this.video_settings(this.recordDetails.id);
        // Set values from API response, fallback to defaults if not provided
        this.form = {
          allow_comments: response?.data?.allow_comments ?? "yes",
          allow_comments_notification:
            response?.data?.allow_comments_notification ?? "no",
          allow_emoji_reactions: response?.data?.allow_emoji_reactions ?? "yes",
          allow_download: response?.data?.allow_download ?? "yes",
          allow_cta_display: response?.data?.allow_cta_display ?? "yes",
          allow_analytics_view: response?.data?.allow_analytics_view ?? "yes",
        };
      } catch (e) {
        console.log(e);
        // Set default values in case of API error
        this.form = {
          allow_comments: "yes",
          allow_comments_notification: "no",
          allow_emoji_reactions: "yes",
          allow_download: "yes",
          allow_cta_display: "yes",
          allow_analytics_view: "yes",
        };
      }
    },
    toggleAudienceSettings() {
      this.$emit("toggle-card");
    },
    async saveAudienceSettings() {
      this.loading = true;
      this.form.recording_id = this.recordDetails.id;
      this.form.user_id = this.recordDetails.user_id;
      try {
        const response = await this.update_analytics_settings(this.form);
        await this.getVideoSettings();
        this.$response.sendSuccess(response);
      } catch (e) {
        this.$response.sendError(e);
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async setDefaultAnalyticsSettings() {
      this.resetLoading = true;
      try {
        const payload = {
          recording_id: this.recordDetails.id,
          user_id: this.recordDetails.user_id,
        };
        const response = await this.set_default_analytics_settings(payload);
        await this.getVideoSettings();
        this.$response.sendSuccess(response);
      } catch (e) {
        this.$response.sendError(e);
        console.error(e);
      } finally {
        this.resetLoading = false;
      }
    },
  },
  mounted() {
    this.getVideoSettings();
  },
};
</script>

<style scoped>
/** Call to action styles */
.call-to-action-left-btn {
  font-weight: 600;
  cursor: pointer;
}
.call-to-action-left-btn:hover {
  color: blue !important;
}
.call-to-action-left-icon {
  margin-top: -4px;
  margin-right: -4px;
}
/* ./ */
.edit-card-subtitle {
  font-size: 13px !important;
}
</style>
